/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planner_ProposeInputs */

const en_planner_propose = /** @type {(inputs: Planner_ProposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggest`)
};

const de_planner_propose = /** @type {(inputs: Planner_ProposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschlagen`)
};

/**
* | output |
* | --- |
* | "Suggest" |
*
* @param {Planner_ProposeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_propose = /** @type {((inputs?: Planner_ProposeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_ProposeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_propose(inputs)
	return en_planner_propose(inputs)
});